var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNpPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.348 93.305c-0.32031 0-0.64453-0.078126-0.9375-0.23438-0.65234-0.34766-1.0625-1.0273-1.0625-1.7656v-82.609c0-0.73828 0.40625-1.418 1.0625-1.7656 0.65234-0.34766 1.4453-0.30469 2.0586 0.10547l61.309 41.305c0.55078 0.37109 0.88281 0.99219 0.88281 1.6602 0 0.66406-0.33203 1.2852-0.88281 1.6602l-61.312 41.305c-0.33594 0.22656-0.72656 0.33984-1.1172 0.33984z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpPlay);
export default __webpack_public_path__ + "static/media/np_play.6b72b85c3426a3d114e3086d55290d9b.svg";
export { ForwardRef as ReactComponent };